<div class="modal-header">
	<h2 [ro-i18n] eikey="dashboard.profile.title"></h2>
</div>
<div class="modal-body">
	<form [formGroup]="profileForm" novalidate (ngSubmit)="onSubmit()" class="needs-validation">

		<div class="form-group">
			<label class="col-form-label" for="firstName" [ro-i18n] eikey="dashboard.profile.labels.firstName">First name</label>
			<input class="form-control"
				id="firstName"
				type="text"
				formControlName="firstName"
				placeholder="{{ placeholders.firstName }}"
				required
				[ngClass]="{ 'is-invalid': submitted && formControls.firstName.errors, 'is-valid': formControls.firstName.touched && !formControls.firstName.errors }" />
			@if (submitted && formControls['firstName'].errors) {
				<div class="invalid-feedback">
					@if (formControls['firstName'].errors.required) {
						<div [ro-i18n] eikey="dashboard.profile.errorMsgs.firstNameReq">First Name is required</div>
					}
				</div>
			}
		</div>

		<div class="form-group">
			<label class="col-form-label" for="lastName" [ro-i18n] eikey="dashboard.profile.labels.lastName">Last name</label>
			<input class="form-control"
				id="lastName"
				type="text"
				formControlName="lastName"
				placeholder="{{ placeholders.lastName }}"
				required
				[ngClass]="{ 'is-invalid': submitted && formControls.lastName.errors, 'is-valid': formControls.lastName.touched && !formControls.lastName.errors }" />
			@if (submitted && formControls['lastName'].errors) {
				<div class="invalid-feedback">
					@if (formControls['lastName'].errors.required) {
						<div [ro-i18n] eikey="dashboard.profile.errorMsgs.lastNameReq">Last Name is required</div>
					}
				</div>
			}
		</div>

		<div class="form-group">
			<label class="col-form-label" for="email" [ro-i18n] eikey="dashboard.profile.labels.emailAddr">Email</label>
			<small [ngStyle]="{'margin-left': '50%'}" [ro-i18n] eikey="dashboard.profile.labels.emailNote"></small>
			<input class="form-control"
				id="email"
				type="text"
				formControlName="email"
				placeholder="{{ placeholders.emailAddr }}"
				autocomplete="email"
				required
				[ngClass]="{ 'is-invalid': submitted && formControls.email.errors, 'is-valid': formControls.email.touched && !formControls.email.errors }" />
			@if (submitted && formControls['email'].errors) {
				<div class="invalid-feedback">
					@if (formControls['email'].errors.required) {
						<div [ro-i18n] eikey="dashboard.profile.errorMsgs.emailReq">Email is required</div>
					}
					@if (formControls['email'].errors.email) {
						<div [ro-i18n] eikey="dashboard.profile.errorMsgs.emailInvalid"></div>
					}
				</div>
			}
		</div>

		<!-- TODO: Image upload (profile picture, signature) — to be implemented when image upload facility is built -->

	</form>
</div>
<div class="modal-footer">
	<div class="form-group">
		<button class="btn btn-outline-primary mr-1" (click)="onSubmit()" [ro-i18n] eikey="general.save" [disabled]="profileForm.pristine">Submit</button>
		<button class="btn btn-outline-light mr-1" type="cancel" (click)="onCancel()" aria-label="Close" [ro-i18n] eikey="general.cancel">Close</button>
		<button class="btn btn-outline-danger" type="reset" [ro-i18n] eikey="general.reset" [disabled]="profileForm.pristine && !submitted" (click)="onReset()">Reset</button>
		<div class="sk-rotating-plane" [hidden]="!submitting"></div>
		@if (errorMessage != null) {
			<div class="invalid-feedback">{{ errorMessage }}</div>
		}
	</div>
</div>
